import { TIPO_MESSENGER, TIPO_INSTAGRAM } from "./canalConexao";
import { ICONES_CANAL } from "../components/IconeCanal";

const DESENHOS = {
  balao: '<path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8z"/>',
  balaoTexto: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M7 8h10M7 12h6"/>',
  aviao: '<path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/>',
  clipe: '<path d="m21.4 11.1-9.2 9.2a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5"/>',
  telefone: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/>',
  microfone: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8"/>',
  visto: '<path d="m2 12.5 4 4 8.5-9M11 15.5l1 1 8.5-9"/>',
  sino: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"/>',
  link: '<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.8 1.7M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>',
  foto: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/>',
  video: '<path d="m23 7-7 5 7 5z"/><rect x="1" y="5" width="15" height="14" rx="2"/>',
  joinha: '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.3a2 2 0 0 0 2-1.7l1.4-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>',
  coracao: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1 7.8 7.7 7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z"/>',
  camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>',
  salvar: '<path d="m19 21-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>',
  reels: '<rect x="2" y="2" width="20" height="20" rx="5"/><path d="M2 8h20M8 2l3 6M14 2l3 6M10 12v6l5-3z"/>',
  hashtag: '<path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"/>',
  arroba: '<circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.9 7.9"/>',
  stories: '<circle cx="12" cy="12" r="10" stroke-dasharray="4 2.6"/><circle cx="12" cy="12" r="6"/>',
};

const FUNDOS = {
  [TIPO_MESSENGER]: {
    desenhos: ["balao", "aviao", "clipe", "visto", "telefone", "foto", "balaoTexto", "microfone", "link", "joinha", "video", "sino"],
    light: { fundo: "#e9eef5", traco: "rgba(8, 102, 255, 0.16)" },
    dark: { fundo: "#0d1520", traco: "rgba(77, 148, 255, 0.17)" },
  },
  [TIPO_INSTAGRAM]: {
    desenhos: ["camera", "coracao", "aviao", "salvar", "reels", "balao", "hashtag", "arroba", "foto", "stories", "link", "clipe"],
    light: { fundo: "#f3ecef", traco: "rgba(193, 53, 132, 0.15)" },
    dark: { fundo: "#17111a", traco: "rgba(214, 87, 160, 0.17)" },
  },
};

const CELULA = 56;
const COLUNAS = 6;
const GIROS = [-12, 8, -4, 14, -16, 5, 18, -8, 3, -14, 10, -2, 12];
const DESVIOS = [[-6, 4], [5, -7], [-3, -5], [7, 6], [0, 8], [-8, -2], [6, 1], [-4, 7], [3, -8]];

// Logo do canal em algumas células da grade, para a estampa dizer o canal mesmo de longe.
const CELULAS_LOGO = [7, 22, 33];

const estampa = (tipo, { traco }) => {
  const { desenhos } = FUNDOS[tipo];
  const lado = CELULA * COLUNAS;
  let corpo = "";
  for (let i = 0; i < COLUNAS * COLUNAS; i++) {
    const coluna = i % COLUNAS;
    const linha = Math.floor(i / COLUNAS);
    const [dx, dy] = DESVIOS[i % DESVIOS.length];
    const x = coluna * CELULA + CELULA / 2 + dx;
    const y = linha * CELULA + CELULA / 2 + dy;
    const giro = GIROS[i % GIROS.length];
    const posicao = `translate(${x} ${y}) rotate(${giro})`;
    if (CELULAS_LOGO.includes(i)) {
      corpo += `<path fill="${traco}" transform="${posicao} scale(1.15) translate(-12 -12)" d="${ICONES_CANAL[tipo].d}"/>`;
    } else {
      // Índice por coluna E linha: com i puro, a grade de 6 casa com os 12 desenhos e
      // o mesmo desenho cai sempre na mesma coluna, formando listras.
      const desenho = desenhos[(coluna * 5 + linha * 3) % desenhos.length];
      const escala = 1 + ((coluna * 2 + linha) % 2) * 0.1;
      corpo += `<g stroke="${traco}" transform="${posicao} scale(${escala}) translate(-12 -12)">${DESENHOS[desenho]}</g>`;
    }
  }
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${lado}" height="${lado}">` +
    `<g fill="none" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">${corpo}</g></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

// O makeStyles do MUI v4 recalcula o estilo dinâmico a cada render do MessagesList (cada
// mensagem que chega); sem o cache, o SVG da estampa seria remontado toda vez.
const cache = {};

// Messenger e Instagram não usam o papel de parede do WhatsApp por baixo: o atendente
// precisa reconhecer o canal pelo fundo, e o desenho do WhatsApp dizia o contrário.
export const fundoConversa = (tipo, theme) => {
  const fundo = FUNDOS[tipo];
  if (!fundo) return theme.backgroundImage;
  const modo = theme.palette && theme.palette.type === "dark" ? "dark" : "light";
  const chave = `${tipo}:${modo}`;
  if (!cache[chave]) {
    const tema = fundo[modo];
    cache[chave] = `${estampa(tipo, tema)}, linear-gradient(${tema.fundo}, ${tema.fundo})`;
  }
  return cache[chave];
};
